import { VacancyHeroBlok } from "storyblok/components";
import { storyblokEditable } from "@storyblok/react";
import { useState } from "react";
import Image from "next/legacy/image";

import { Button, Input } from "components/ui";

import {
    ButtonWrapper,
    Description,
    Fields,
    ImageWrapper,
    Left,
    StyledContainer,
    Title,
    Wrapper
} from "./VacancyHero.styled";

type Props = {
    blok: VacancyHeroBlok;
};

export function VacancyHero({ blok }: Props): JSX.Element {
    const [searchTerm, setSearchTerm] = useState<string | null>(null);
    const [isZzp] = useState("Nee");

    const { title, description } = blok;

    return (
        <Wrapper {...storyblokEditable(blok)}>
            <ImageWrapper>
                <Image
                    src="/images/vacancy-hero.webp"
                    priority
                    loading="eager"
                    alt="Vacancy hero banner"
                    layout="responsive"
                    width={698}
                    height={494}
                />
            </ImageWrapper>
            <StyledContainer>
                <Left>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                    <Fields>
                        <Input
                            label="Zoek vacatures"
                            name="vacatureSearch"
                            placeholder="Bijvoorbeeld: “Verpleegkundige”"
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </Fields>

                    <ButtonWrapper>
                        <Button
                            disabled={!searchTerm}
                            buttonType="primary"
                            href={`/zorgprofessionals/${
                                isZzp === "Ja" ? "opdrachten" : "vacatures"
                            }/${
                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                searchTerm && `?search=${searchTerm}`
                            }`}
                        >
                            Zoeken
                        </Button>
                        <Button
                            buttonType="ghost"
                            href="/zorgprofessionals/vacatures"
                        >
                            Alle vacatures
                        </Button>
                        <Button
                            buttonType="ghost"
                            href="/zorgprofessionals/opdrachten"
                        >
                            Alle zzp-opdrachten
                        </Button>
                    </ButtonWrapper>
                </Left>
            </StyledContainer>
        </Wrapper>
    );
}
